import styles from './segmented-control.module.css';

export type SegmentedOption = {
  value: string;
  label: string;
};

type SegmentedControlProps = {
  label: string;
  name: string;
  options: SegmentedOption[];
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  hideLabel?: boolean;
  disabled?: boolean;
};

export const SegmentedControl = ({
  label,
  name,
  options,
  value,
  onChange,
  onBlur,
  hideLabel = false,
  disabled = false,
}: SegmentedControlProps) => (
  <fieldset className={styles.group} disabled={disabled}>
    <legend className={hideLabel ? styles.legendHidden : styles.legend}>{label}</legend>
    <div className={styles.track}>
      {options.map((option) => (
        <label key={option.value} className={styles.option}>
          <input
            className={styles.input}
            type="radio"
            name={name}
            value={option.value}
            checked={option.value === value}
            onChange={() => {
              onChange(option.value);
            }}
            onBlur={onBlur}
          />
          <span className={styles.optionLabel}>{option.label}</span>
        </label>
      ))}
    </div>
  </fieldset>
);
